import { render, staticRenderFns } from "./CrMenu.vue?vue&type=template&id=ab875f7a"
import script from "./CrMenu.vue?vue&type=script&lang=js"
export * from "./CrMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports